import React, { useState, useEffect } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { fetchAuthSession } from 'aws-amplify/auth';
import config from '../../amplifyconfiguration.json';
import { SignatureV4 } from "@aws-sdk/signature-v4";
import { HttpRequest } from "@aws-sdk/protocol-http";
import { Sha256 } from "@aws-crypto/sha256-browser";
import "./planui.css"
const baseURL = process.env.REACT_APP_BASE_URL;
const endpoint_mes = '/get_messages_user';

const Plan = () => {
    const [messages, setMessages] = useState([]);
    const { user } = useAuthenticator((context) => [context.user]);
    const id_user = user.username;

    const createAuthenticatedRequest = async (config) => {
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        const my_login = 'cognito-idp.' + config.aws_project_region + '.amazonaws.com/' + config.aws_user_pools_id;

        const credentials = fromCognitoIdentityPool({
            clientConfig: { region: config.aws_project_region },
            identityPoolId: config.aws_cognito_identity_pool_id,
            logins: { [my_login]: authToken }
        });

        const signer = new SignatureV4({
            credentials: credentials,
            region: config.aws_project_region,
            service: 'execute-api',
            sha256: Sha256
        });

        return async (endpoint, method = 'GET', body = null) => {
            const url = new URL(endpoint);

            const request = new HttpRequest({
                hostname: url.hostname,
                path: url.pathname + url.search,
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    host: url.hostname
                },
                body: body ? JSON.stringify(body) : undefined
            });

            const signedRequest = await signer.sign(request);

            const fetchOptions = {
                method: signedRequest.method,
                headers: signedRequest.headers,
                body: signedRequest.body
            };

            const response = await fetch(url.toString(), fetchOptions);
            return response.json();
        };
    };

    useEffect(() => {
        const fetchMessages = async () => {
            if (id_user) {
                try {
                    const authenticatedRequest = await createAuthenticatedRequest(config);
                    const url = `${baseURL}${endpoint_mes}?id_user=${encodeURIComponent(id_user)}`;

                    const response = await authenticatedRequest(url, 'GET', null);
                    console.log("ESTIO ES ", response.messages.Items)
                    if (response &&  response.messages) {
                        setMessages(response.messages.Items);
                    } else {
                        console.warn('No messages data in response:', response);
                        setMessages([]);
                    }
                } catch (error) {
                    console.error('Error fetching messages:', error);
                    setMessages([]);
                }
            }
        };

        fetchMessages();
    }, [id_user, config]);

    // Calcular valores para la tabla
    const messageCount = messages.length;
    const tokensEntrada = messageCount * 4* 42; // Ejemplo: 5 tokens por mensaje
    const tokensSalida = messageCount * 2* 63; // Ejemplo: 3 tokens por mensaje


    return (
        <div className="plan-container">
        <h1>Plan</h1>
        <table className="table" style={{ borderCollapse: "separate", borderSpacing: "15px" }}>
            <thead>
                <tr>
                    <th style={{ textAlign: "left", padding: "10px" }}>Usuario</th>
                    <th style={{ textAlign: "left", padding: "10px" }}>Mensajes</th>
                    <th style={{ textAlign: "left", padding: "10px" }}>Tokens Input</th>
                    <th style={{ textAlign: "left", padding: "10px" }}>Tokens Output</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style={{ textAlign: "left", padding: "10px" }}>{id_user}</td>
                    <td style={{ textAlign: "left", padding: "10px" }}>{messageCount}</td>
                    <td style={{ textAlign: "left", padding: "10px" }}>{tokensEntrada}</td>
                    <td style={{ textAlign: "left", padding: "10px" }}>{tokensSalida}</td>
                </tr>
            </tbody>
        </table>
    </div>
    
    );
};

export default Plan;